module.exports = __webpack_public_path__ + "static/media/fullLogoLight.422442ee.png";